module.exports = __webpack_public_path__ + "static/media/ASAB.0d903109.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/ASAB.jpg
// module id = 1709
// module chunks = 1